export const FETCH_FEED_REQUEST = 'FETCH_FEED_REQUEST';
export const FETCH_FEED_SUCCESS = 'FETCH_FEED_SUCCESS';
export const FETCH_FEED_FAILURE = 'FETCH_FEED_FAILURE';

export const FETCH_FEED_STATISTICS = 'FETCH_FEED_STATISTICS';
export const FETCH_FEED_STATISTICS_SUCCESS = 'FETCH_FEED_STATISTICS_SUCCESS';
export const FETCH_FEED_STATISTICS_FAILURE = 'FETCH_FEED_STATISTICS_FAILURE';

export const FETCH_FEED_POST_STATISTICS = 'FETCH_FEED_POST_STATISTICS';
export const FETCH_FEED_POST_STATISTICS_SUCCESS = 'FETCH_FEED_POST_STATISTICS_SUCCESS';
export const FETCH_FEED_POST_STATISTICS_FAILURE = 'FETCH_FEED_POST_STATISTICS_FAILURE';

export const SET_FEED_USER_ID = 'SET_FEED_USER_ID';
export const CLEAR_FEED = 'CLEAR_FEED';

export const FETCH_COMMENTS_SUCCESS = 'FETCH_COMMENTS_SUCCESS';
export const COMMENT_ON_POST_SUCCESS = 'COMMENT_ON_POST_SUCCESS';

export const REPPLY_ON_COMMENT_SUCCESS = 'REPPLY_ON_COMMENT_SUCCESS';

export const LIKE_TOGGLE = 'LIKE_TOGGLE';
export const COMMENT_LIKE_TOGGLE = 'COMMENT_LIKE_TOGGLE';
export const REPLY_LIKE_TOGGLE = 'REPLY_LIKE_TOGGLE';
export const BOOKMARK_TOGGLE = 'BOOKMARK_TOGGLE';

export const DELETE_POST = 'DELETE_POST';

export const FETCH_POST_REQUEST = 'FETCH_POST_REQUEST';
export const FETCH_POST_SUCCESS = 'FETCH_POST_SUCCESS';
export const FETCH_POST_FAILURE = 'FETCH_POST_FAILURE';

export const PURCHASE_POST_SUCCESS = 'PURCHASE_POST_SUCCESS';
export const DELETE_CARD = 'DELETE_CARD';

export const PIN_POST_REQUEST = 'PIN_POST_REQUEST';
export const PIN_POST_SUCCESS = 'PIN_POST_SUCCESS';
export const PIN_POST_FAILURE = 'PIN_POST_FAILURE';
